import { useMemo } from 'react';
import { tabsFor, type TabId } from '@/lib/driverAppTabs';
import { useUserCompanies } from './useUserCompanies';

/**
 * The tabs the signed-in member sees in the selected company, from their
 * office role and whether they drive. Empty until the membership is known.
 */
export const useDriverTabs = (): { tabs: TabId[]; isLoading: boolean } => {
  const { companies, selectedCompanyId } = useUserCompanies();
  const membership = companies.find(
    (seat) => seat.company.id === selectedCompanyId
  );
  const officeRole = membership?.officeRole ?? null;
  const drives = membership?.drives ?? false;

  return useMemo(
    () =>
      !membership
        ? { tabs: [], isLoading: true }
        : { tabs: tabsFor({ officeRole, drives }), isLoading: false },
    [membership, officeRole, drives]
  );
};
